import { onMounted, onUnmounted, nextTick } from 'vue'
import select from 'dom-select'
import on from 'dom-event'

export default (props, { emit }) => {
  function close () {
    emit('update:isActive', false)
  }

  function open () {
    emit('update:isActive', true)
  }

  function toggle () {
    props.isActive ? close() : open()
  }

  function attachEvents () {
    if (props.activatorSelector) {
      const activator = select(props.activatorSelector)
      if (activator) on(activator, 'click', open)
    }
  }

  function detachEvents () {
    if (props.activatorSelector) {
      const activator = select(props.activatorSelector)
      if (activator) on.off(activator, 'click', open)
    }
  }

  onMounted(() => {
    nextTick(attachEvents)
  })

  onUnmounted(() => {
    nextTick(detachEvents)
  })

  return {
    open,
    close,
    toggle
  }
}
